import lineDelete from 'slate-delete-one-line';

export default lineDelete();
